// extracted by mini-css-extract-plugin
module.exports = {"container":"content_container__GjF4J","content":"content_content__U56BT"};